module.exports = __webpack_public_path__ + "static/media/stracka.08bcedff.mp3";